import { Navigate, useLocation } from 'react-router-dom'
import { useAuthContext } from '../context/AuthContext'
import { TrialBanner } from './ui/TrialBanner'

// Pages where a plain trial/nudge banner would be redundant or actively
// annoying (e.g. the upgrade page itself). Keep this list tight — the banner
// is the main channel we have for surfacing the retrospective-value nudge on
// V2 pages that don't import it manually.
const UPGRADE_PATHS = ['/billing/upgrade', '/upgrade', '/upgrade/v2', '/upgrade/classic', '/billing/success']

export function ProtectedRoute({ children }) {
  const { user, loading, accessBlocked } = useAuthContext()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen bg-ivory flex items-center justify-center">
        <div className="text-mid text-sm">Loading…</div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (accessBlocked && !UPGRADE_PATHS.includes(location.pathname)) {
    return <Navigate to="/billing/upgrade" replace />
  }

  // Render the banner above the routed page content. V1 pages that still
  // import <TrialBanner /> locally will dedupe via its module-level primary
  // flag — only this outer instance actually renders. Upgrade pages are
  // excluded since the banner's sole CTA routes there anyway.
  const showBanner = !UPGRADE_PATHS.includes(location.pathname)
  return (
    <>
      {showBanner && <TrialBanner />}
      {children}
    </>
  )
}
